import React from 'react';
import { OfferProps } from '../types';
import { FeaturesSectionRecord, SiteLocale } from '../../../../../types/dato';
import { getPlanIcon } from '../scripts/getPlanIcon';
import { classNames } from '@payfit/growth-platform-brand-system-v2';
import { Icon } from '@payfit/growth-platform-brand-system-v2/components/Picto/Icon';
import { fontBodyMini } from '@payfit/growth-platform-brand-system-v2/styles/typographyNew';
import { PictoName } from '@payfit/growth-platform-brand-system-v2/components/Picto/pictosLibrary';
import Feature from './Feature';
import { translation } from '../scripts/translation';

export default function FeaturesSections({
  featuresSections,
  index,
  previousOffer,
  locale,
}: {
  featuresSections: FeaturesSectionRecord[];
  index: number;
  previousOffer?: OfferProps | null;
  locale: SiteLocale;
}) {
  const prevIcon = getPlanIcon({ name: previousOffer?.icon, index: index - 1 });
  return (
    <div className={classNames(fontBodyMini, 'flex flex-col gap-[12px]')}>
      {previousOffer ? (
        <div className={classNames('flex items-center gap-[8px]')}>
          {translation[locale]?.['features.plan.prefix']}
          {prevIcon && (
            <Icon name={prevIcon} className={classNames('h-[28px] w-[28px]')} />
          )}
          <span className={classNames('font-medium')}>
            {previousOffer.title},
          </span>
          {translation[locale]?.['features.plan.suffix']}
        </div>
      ) : (
        <div>{translation[locale]?.['features.plan.default']}</div>
      )}
      <dl className="flex flex-col gap-[24px]">
        {featuresSections.map((section, index) => (
          <div
            key={section.id || 'section-' + index}
            className="flex flex-col gap-[12px]"
          >
            <dt className={classNames('font-medium')}>
              {section?.picto?.name && (
                <Icon
                  name={section.picto.name as PictoName}
                  width={20}
                  height={20}
                  twTextColor="text-[#364A61]"
                  className={classNames(
                    'mr-[6px] inline h-[20px] w-[20px]',
                    'relative -top-[2px]',
                  )}
                />
              )}
              {section.title}
            </dt>
            {section.features.map((feature, index) => {
              return <Feature key={index} feature={feature} />;
            })}
          </div>
        ))}
      </dl>
    </div>
  );
}
